import { Pie as RechartsPie } from 'recharts';

export const Pie = (
    props: React.ComponentProps<typeof RechartsPie>
) => {
    return <RechartsPie data-testid={'Pie-container'} {...props} />;
};

export default Pie;
